import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';
import { IconsSkeleton } from './SparkPopupHeaderSkeleton';
type SparkRunByIDSkeletonProps = {
  count?: number;
  renderHeaderSkeleton?: boolean;
};
function SparkRunByIDSkeleton({
  count = 2,
  renderHeaderSkeleton = true,
}: SparkRunByIDSkeletonProps) {
  const NO_OF_ITEMS_ARRAY: number[] = [];

  for (let i = 1; i <= count; i++) {
    NO_OF_ITEMS_ARRAY.push(i);
  }
  return (
    <Grid container alignItems='center' direction='column'>
      {renderHeaderSkeleton && (
        <Grid
          container
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          bgcolor='white'
          height='6rem'
        >
          <Grid
            display='flex'
            sx={{
              alignItems: 'center',
            }}
            marginX={2}
            alignItems='center'
            gap={3}
          >
            <Skeleton
              variant='rounded'
              width={45}
              height={45}
              sx={{ borderRadius: '14px' }}
            />
            <Skeleton
              variant='rounded'
              width={75}
              height={75}
              sx={{ borderRadius: '14px' }}
            />
            <Box>
              <Skeleton variant='text' width={170} height={40} />
              <Skeleton variant='text' width={100} height={30} />
            </Box>
          </Grid>

          <Grid
            item
            container
            flex={1}
            gap={0.8}
            justifyContent='flex-end'
            flexWrap='nowrap'
            marginX={2}
          >
            <IconsSkeleton />
            <IconsSkeleton />
            <IconsSkeleton />
          </Grid>
        </Grid>
      )}
      <Grid
        container
        item
        flex={1}
        gap={2}
        justifyContent='center'
        style={{ maxWidth: '800px', width: '100%' }}
        sx={{ height: 'calc(100vh - 6rem)' }}
      >
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          bgcolor='white'
          marginTop={2}
          border='1px solid #EEEEEE'
          borderRadius='10px'
          padding={2}
          paddingBottom={2}
          width='100%'
        >
          <Box display='flex' alignItems='center' gap={1}>
            <Skeleton variant='circular' height={50} width={50} />
            <Skeleton variant='text' height={20} width={50} />
            <Skeleton variant='text' height={20} width={60} />
          </Box>
          <Skeleton variant='circular' height={20} width={20} />
        </Box>
        <Grid container spacing={2}>
          {NO_OF_ITEMS_ARRAY.map((value) => (
            <Grid item xs={12} key={value}>
              <Box
                sx={{
                  backgroundColor: 'white',
                  border: '1px solid #EEEEEE',
                  borderRadius: '10px',
                  padding: '32px 32px 12px 32px',
                }}
              >
                <Skeleton variant='text' height={20} width='20%' />
                <Skeleton
                  variant='text'
                  height={65}
                  sx={{ marginBottom: 2, padding: 1 }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SparkRunByIDSkeleton;
